import React, { useEffect, useState } from "react"

import { BellRinging, X } from "@phosphor-icons/react"
import { Dialog, DialogPanel } from "@headlessui/react"
import InputField from "@components/common/InputField"
import { getShopifyImage } from "gatsby-source-shopify"
import { GatsbyImage } from "gatsby-plugin-image"

const NotifyMeModal = ({ productName, size, product_id, notifySizes = [], isOpen = false, onClose = () => {}}) => {
    const [email, setEmail] = useState('')
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const [sizeSelected, setSizeSelected] = useState()

    const handleClose = () => {
        setSizeSelected([])
        setSuccess(false)
        onClose()
    }

    const handleSizeSelected = (item) => {
        setSizeSelected(item)
    }

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSendMeNotification = async () => {
    
        if (!validateEmail(email)) {
            setError("Please enter a valid email.");
            return;
        }
        setError("");
        
        try {
            const variantId = size?.id?.replace("gid://shopify/ProductVariant/", "");
            const productId = product_id?.replace("gid://shopify/Product/", "");

            const response = await fetch("https://r3-t.trackedlink.net/product-notifications", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    productId,
                    variantId,
                    email,
                    ddID: process.env.GATSBY_STORE !== "PH" ? "7R45" : "7R48",
                    notificationSettingsID: process.env.GATSBY_STORE !== "PH" ? 14 : 15
                }),
            });
            
            if (response.status === 202) {
                setSuccess(true);
                setEmail("");
            } else {
                onClose()
            }
        } catch (err) {
            onClose()
            console.log(err)
        }
    }

    const filename = productName?.[1]?.replace("FINAL SALE", "")?.replace(" ", "-")?.toLowerCase()?.trim();
    
    const colorData = {
        originalSrc: `https://cdn.shopify.com/s/files/1/1219/5720/files/${filename}.png`,
        width: 48,
        height: 48,
    };

    const gatsbyColorImage = getShopifyImage({
        image: colorData ?? colorData,
        layout: "constrained",
        crop: "contain",
        width: 48,
        height: 48,
    })

    const openState = isOpen || false;

    useEffect(() => {
        setSizeSelected(size)
    }, [size]);
    
    return (
        <React.Fragment>
            <Dialog open={openState} onClose={handleClose} className="relative z-[999]">
                <div className="fixed inset-0 w-screen overflow-y-auto p-4 bg-black bg-opacity-60">
                    <div className="flex min-h-full items-center justify-center">
                        <DialogPanel className="relative border bg-white p-6 w-128 overflow-y-auto minimalist-scrollbar gap-6">
                            <X
                                className="absolute top-0 right-0 cursor-pointer text-black m-4"
                                size={32}
                                weight="light"
                                onClick={handleClose}
                            />
                            
                            {
                                success !== true ?
                                <>
                                    <section className="">
                                        <div className="flex flex-1 gap-2 items-center">
                                            <div>
                                                <GatsbyImage
                                                    className={`border-2 border-black opacity-50 circle-8`}
                                                    style={{overflow: "hidden", width: "48px", height: "48px", borderRadius: "50%"}}
                                                    objectFit="contain"
                                                    loading="lazy"
                                                    alt={`${productName?.[1]?.replace("FINAL SALE", "")}`}
                                                    image={gatsbyColorImage ?? gatsbyColorImage}
                                                />
                                            </div>
                                            <div>
                                                <h1 className="leading-normal text-[20px] mr-10">{productName?.[0]?.replace("FINAL SALE", "")}</h1>
                                                <h4>{productName?.[1]?.replace("FINAL SALE", "")}</h4>
                                            </div>
                                        </div>

                                        <div className="text-xs space-x-2 text-primary pt-10">
                                            <span className="font-semibold">NOTIFY FOR:</span>
                                            <span>{sizeSelected?.title}</span>
                                        </div>

                                        <div className="flex flex-nowrap gap-x-2 py-8">
                                            {notifySizes?.map((item, index) => (
                                                <button
                                                    key={index}
                                                    className={`${(sizeSelected?.id === item?.id) ? 'text-white bg-black' : 'text-black bg-white'} relative py-2 px-4 border border-black w-[120px]`}
                                                    onClick={() => handleSizeSelected(item)}
                                                    aria-label={item?.title}
                                                >
                                                    {item?.title}
                                                </button>
                                            ))}
                                        </div>

                                        <div className="space-y-2 text-xs">
                                            <InputField
                                                id="email"
                                                label="YOUR EMAIL ADDRESS"
                                                placeholder="johndoe@example.com"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                inputClassName={`${
                                                    error ? "ds-input border-red-500" : "ds-input"
                                                }`}
                                                labelOnTop
                                            />
                                            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
                                            <h4>Be the first to receive stock updates for this product.</h4>
                                        </div>
                                    </section>

                                    <div className="w-full flex pt-8">
                                        <button 
                                            className='w-full btn-primary text-primary flex gap-2 justify-center items-center'
                                            onClick={() => handleSendMeNotification()}
                                        >
                                            <BellRinging size={20} weight='light' />
                                            <span>Notify me when available</span>
                                        </button>
                                    </div>
                                </> : 
                                <>
                                    <h1 className="mt-5 text-center text-2xl">Thanks for signing up</h1>
                                    <p className="text-center text-xl mt-5 mb-5">We'll let you know once it's available</p>
                                </>
                            }
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    );
}

export default NotifyMeModal